import React from 'react';

import {
  deltaTone,
  formatDelta,
  smallPointsBalance,
  type StandingRow,
} from './scoring-types';

interface Props {
  rows: StandingRow[];
  showPoints: boolean;
  testId?: string;
  onPickPlayer?: (row: StandingRow) => void;
}

export const ScoringStandings: React.FC<Props> = ({
  rows,
  showPoints,
  testId = 'scoring-standings',
  onPickPlayer,
}) => {
  if (rows.length === 0) {
    return null;
  }

  function onRowKeyDown(event: React.KeyboardEvent, row: StandingRow): void {
    if (!onPickPlayer || (event.key !== 'Enter' && event.key !== ' ')) {
      return;
    }

    event.preventDefault();
    onPickPlayer(row);
  }

  return (
    <div className="scoring-standings" data-testid={testId}>
      <table className="scoring-standings__table">
        <thead>
          <tr>
            <th className="scoring-standings__rank">#</th>
            <th>Zawodnik</th>
            <th title="Rozegrane mecze">M</th>
            <th title="Wygrane mecze">W</th>
            <th title="Sety wygrane : przegrane">Sety</th>
            <th title="Bilans lotek — małe punkty zdobyte minus stracone">Lotki</th>
            {showPoints && (
              <th title="Punkty za sety wg systemu punktacji tej grupy">Pkt</th>
            )}
            <th title="Punkty do klasyfikacji sezonu za miejsce w grupie — 1. miejsce w pierwszej grupie = 300, każde kolejne −10">
              Klas.
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr
              key={row.leaguePlayerId}
              data-testid={`standing-${row.leaguePlayerId}`}
              className={onPickPlayer ? 'scoring-standings__row--pickable' : undefined}
              role={onPickPlayer ? 'button' : undefined}
              tabIndex={onPickPlayer ? 0 : undefined}
              title={onPickPlayer ? `Mecze — ${row.name}` : undefined}
              onClick={onPickPlayer ? () => onPickPlayer(row) : undefined}
              onKeyDown={(event) => onRowKeyDown(event, row)}
            >
              <td className="scoring-standings__rank">{row.rank}</td>
              <td className="scoring-standings__name">{row.name}</td>
              <td>{row.played}</td>
              <td className="scoring-standings__wins">{row.wins}</td>
              <td className="scoring-standings__sets">{row.setsWon}:{row.setsLost}</td>
              <td className={`scoring-standings__small ${deltaTone(smallPointsBalance(row))}`}>
                {formatDelta(smallPointsBalance(row))}
              </td>
              {showPoints && <td className="scoring-standings__points">{row.points}</td>}
              <td className="scoring-standings__placement">{row.placementPoints}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ScoringStandings;
